<!-- 基础资料 工程分类 描述与详情 -->
<div class="main">
  <div class="mian-content">
    <!-- 基础资料 -->
    <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'DetailInfo.BasicData' | translate }}</h4>
    <nz-list nzBordered>
      <nz-list-item>
        <!-- invoices: 申请人 联系方式 -->
        <div class="sign-tag" *ngFor="let item of invoices">
          <span class="head-span1" nz-typography>{{ item.text | translate }}</span>
          <span class="head-span2">{{ DetailData[item.value] }}</span>
        </div>
      </nz-list-item>
      <nz-list-item>
        <!-- userMsg: 单号 申请日期 -->
        <div class="sign-tag" *ngFor="let item of userMsg">
          <span class="head-span1">{{ item.text | translate }}</span>
          <span class="head-span2">{{ DetailData[item.value] }}</span>
        </div>
      </nz-list-item>
      <nz-list-item>
        <!-- 地点: 园区	区域	建筑名称	楼层	功能单元间	门牌编号-->
        <div class="sign-area">
          <span class="head-span1" nz-typography>{{ 'DocApp.Location' | translate }}</span>
          <div [ngClass]="{'activate':activate == true}">
            <nz-table #basicTable [nzData]="siteMsg" [nzShowPagination]="false">
              <thead class="area-header">
                <tr>
                  <th scope="col" class="head-span2" *ngFor="let item of siteMsg">{{ item.text | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td *ngFor="let item of siteMsg">{{DetailData[item.value]}}</td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </nz-list-item>
    </nz-list>

    <!-- 工程分类 -->
    <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'DocApp.EngineeringCategory' | translate }}</h4>
    <ng-container *ngIf="!isEdit; else elseTemplate">
      <nz-list nzBordered>
        <nz-list-item style=" width: 60%;">
          <label class="checkbox" nz-checkbox [nzDisabled]=!isEdit [(ngModel)]="civilEngineering">{{ 'DetailInfo.CIVIL' | translate }}</label>
          <label class="checkbox" style="margin-left: 100px;" nz-checkbox [nzDisabled]=!isEdit
            [(ngModel)]="electromechanical">{{ 'DetailInfo.ELECTRO' | translate }}</label>
        </nz-list-item>
      </nz-list>
    </ng-container>
    <ng-template #elseTemplate>
      <nz-list nzBordered>
        <nz-list-item style=" width: 100%;">
          <label class="checkbox" nz-checkbox [ngModel]="civilEngineering"
            (ngModelChange)="nzChanged($event,'civilEngineering')">{{ 'DocApp.CivilEngineering' | translate }}</label>
          <label class="checkbox" nz-checkbox [ngModel]="electromechanical"
            (ngModelChange)="nzChanged($event,'electromechanical')">{{ 'DocApp.ElecEngineering' | translate }}</label>
        </nz-list-item>
      </nz-list>
    </ng-template>

    <!-- 描述与详情 -->
    <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'DocApp.DescriptionDetails' | translate }}</h4>
    <nz-list nzBordered>
      <!-- 需求描述:只有我的单据--变更需求才可修改 -->
      <nz-list-item>
        <span nz-typography class="content-name">{{ 'DocApp.DemandsDescription' | translate }}</span>
        <textarea class="area-style" style="min-height: 40px; height:auto!important;" [readonly]='step === 0 ?(!isEdit):true' nz-input
          [(ngModel)]="DetailData['description']" [placeholder]="'DocApp.DemandsDescriptionNote' | translate"
          (ngModelChange)="nzChanged($event,'description')">
        </textarea>
      </nz-list-item>
      <!-- 现况区域照片 -->
      <nz-list-item>
        <span nz-typography class="content-name">{{ 'DocApp.OnSitePhoto' | translate }}</span>
        <div class="area-style" style="min-height: 60px; height:auto!important;">
          <app-preview-upload [disabled]='!nzShowButton' [nzListType]="nzListType" [isImageStatus]="true"
            [nzShowUploadList]="nzShowUploadListOfImage" (isUpload)="isUpload($event,'image')" [fileList]="imageList"
            [nzShowButton]="nzShowButton && isEditImage">
          </app-preview-upload>
        </div>
      </nz-list-item>
      <!-- 上传需求方案 -->
      <nz-list-item>
        <span nz-typography class="content-name">{{ 'DocApp.UploadDemandsPlan' | translate }}</span>
        <div class="area-style" style="height: auto;margin-bottom: 10px;">
          <app-preview-upload [disabled]='!nzShowButton' [nzName]="nzName" [nzShowButton]="nzShowButton"
            [nzShowUploadList]="nzShowUploadList" (isUpload)="isUpload($event,'requireDocs')" [fileList]="fileList">
          </app-preview-upload>
        </div>
      </nz-list-item>
    </nz-list>
  </div>
</div>